import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";

customerAddressFormFieldStyles.stateGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerAddressFormFieldStyles.postalCodeGridItem = {
    width: 12,
};
customerAddressFormFieldStyles.companyNameGridItem = {
    width: [12, 12, 12, 12, 6],
};
customerAddressFormFieldStyles.attentionGridItem = {
    width: [12, 12, 12, 12, 6],
};
customerAddressFormFieldStyles.phoneGridItem = {
    width: [12, 12, 12, 12, 12],
};

